import { render, staticRenderFns } from "./slotRemark.vue?vue&type=template&id=c8bac2dc"
import script from "./slotRemark.vue?vue&type=script&lang=js"
export * from "./slotRemark.vue?vue&type=script&lang=js"
import style0 from "./slotRemark.vue?vue&type=style&index=0&id=c8bac2dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports